import { Input } from '@mantine/core';

import { neutral } from '@/styles/colors';

interface InputLabelProps {
  label: string;
  name: string;
  labelColor?: string;
}

const InputLabel = (props: InputLabelProps) => {
  const { label, name, labelColor } = props;
  return (
    <Input.Label
      htmlFor={name}
      styles={{
        label: {
          color: labelColor || neutral[4],
          fontSize: 12,
          fontWeight: 'bold',
          textTransform: 'uppercase'
        }
      }}>
      {label}
    </Input.Label>
  );
};

export default InputLabel;
